import axios from 'axios'
import tangular from 'tangular'
import FetchFilter from './FetchFilter'
import { replace as glide } from './Glide'

export default class FetchList {
  constructor (node) {
    this.node = node
    this.init()
  }

  init () {
    this.initConfig()
    this.initFilter()
    const templateNode = this.node.querySelector('template')
    this.template = tangular.compile(templateNode.innerHTML)
    this.items = this.node.querySelector('[data-role=list]')
    this.button = this.node.querySelector('[data-role=more]')

    this.button.addEventListener('click', e => this.loadMore())

    this.loadMore()
  }

  initFilter () {
    const filterNode = document.querySelector('.fetch-filter')

    if (filterNode) {
      this.filter = new FetchFilter(filterNode, () => this.onFilter())
    }
  }

  initConfig () {
    this.config = { ...this.node.dataset, current_amount: 0 }

    if (!this.config.collection) {
      throw new Error('Please provide collection name')
    }
  }

  onFilter () {
    this.config.current_amount = 0
    this.loadMore()
  }

  reset () {
    while (this.items.firstChild) {
      this.items.removeChild(this.items.firstChild)
    }
  }

  loadMore () {
    if (this.loading) {
      return false
    }

    this.loading = true
    this.node.classList.add('is-loading')

    const params = {
      offset: this.config.current_amount,
      limit: this.config.limit || 10,
      filter: 'published',
      taxonomy: this.filter ? this.filter.generateTaxonomyQuery() : null,
    }

    axios.post(`/!/Fetch/collection/${this.config.collection}`, params)
      .then(response => this.handleSuccessResponse(response))
      .catch(error => {
        console.error(error)
      }).finally(() => {
        this.loading = false
        this.node.classList.remove('is-loading')
      })
  }

  handleSuccessResponse (response) {
    this.button.style.display = response.data.has_next_page ? 'block' : 'none'

    if (this.config.current_amount === 0) {
      this.reset()
    }

    this.config.current_amount += response.data.data.length
    const noResults = this.node.querySelector('[data-role=no_results]')
    if (noResults) {
      noResults.style.display = response.data.total_results === 0 ? 'block' : 'none'
    }

    response.data.data.forEach((item, index) => {
      const element = this.generateListItem({
        ...item,
        index: index + response.data.offset
      })
      this.items.append(element)
    })

    window.lazyLoad.update()
    document.querySelectorAll('.lightgallery').forEach(gallery => {
      const id = gallery['lg-uid']
      if (id) {
        window.lgData[id].destroy(true)
      }
      window.lightGallery(gallery)
    })
  }

  generateListItem (data) {
    const wrapper = document.createElement('div')
    wrapper.innerHTML = this.template(data).trim()
    const node = wrapper.firstChild
    glide(node)

    return node
  }
}



// WEBPACK FOOTER //
// ./themes/default/js/models/FetchList.js